import _regeneratorRuntime from "/home/runner/work/intro-3d-main/intro-3d-main/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/runner/work/intro-3d-main/intro-3d-main/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/intro-3d-main/intro-3d-main/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectDestructuringEmpty from "/home/runner/work/intro-3d-main/intro-3d-main/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import Viewer from '../viewer';
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { firestore } from '@lib/firebase';
import { useDispatch, useSelector } from '@store';
import VrButton from '@components/Button/Vr';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var prod = 'intro_3d';
var dev = 'dev_intro_3d';
function Kiosk(_ref) {
    _objectDestructuringEmpty(_ref);
    var dispatch = useDispatch();
    var _useSelector = useSelector(function (state) { return state.global; }), lang = _useSelector.lang;
    var _useParams = useParams(), id = _useParams.id;
    var _useState = useState({}), _useState2 = _slicedToArray(_useState, 2), vrLinks = _useState2[0], setVrLinks = _useState2[1];
    var _useState3 = useState(true), _useState4 = _slicedToArray(_useState3, 2), isLoading = _useState4[0], setLoading = _useState4[1];
    useEffect(function () { function fetchData() { return _fetchData.apply(this, arguments); } function _fetchData() { _fetchData = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() { var querySnapshot, _querySnapshot$docs$, vrLink; return _regeneratorRuntime().wrap(function _callee$(_context) { while (1)
        switch (_context.prev = _context.next) {
            case 0:
                _context.prev = 0;
                _context.next = 3;
                return firestore().collection(prod).where('title', '==', "".concat(id, "_kiosk")).get();
            case 3:
                querySnapshot = _context.sent;
                _querySnapshot$docs$ = querySnapshot.docs[0].data(), vrLink = _querySnapshot$docs$.vrLink;
                setVrLinks(vrLink);
                setLoading(false);
                _context.next = 12;
                break;
            case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.error('fetchData : ' + _context.t0);
            case 12:
            case "end": return _context.stop();
        } }, _callee, null, [[0, 9]]); })); return _fetchData.apply(this, arguments); } fetchData(); }, []);
    useEffect(function () {
        var hideFullscreenExitButton = function hideFullscreenExitButton() {
            document.addEventListener('fullscreenchange', function () {
                var fullscreenElement = document.fullscreenElement;
                if (fullscreenElement) { // 전체 화면 진입 시 전체 화면 종료 버튼을 숨깁니다.
                    // fullscreenElement.querySelector('::-webkit-media-controls-fullscreen-exit-button').style.display = 'none';
                }
            });
        };
        hideFullscreenExitButton();
        return function () { document.removeEventListener('fullscreenchange', hideFullscreenExitButton); };
    }, []); // 우클릭 방지를 위한 이벤트 핸들러
    function handleContextMenu(e) {
        e.preventDefault(); // 기본 우클릭 이벤트 동작을 막습니다.
    } // 길게 누르기 이벤트를 막기 위한 더블 탭 방지 함수
    function handleTouchStart(e) {
        if (e.touches.length > 1) {
            e.preventDefault(); // 다중 터치 이벤트를 막습니다.
        }
    }
    if (isLoading)
        return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsxs("div", { onContextMenu: handleContextMenu, onTouchStart: handleTouchStart, children: [/*#__PURE__*/ _jsx(Viewer, { isKiosk: true }), vrLinks && /*#__PURE__*/ _jsx(VrButton, { value: vrLinks[lang] })] }) });
}
export default Kiosk;
